<template>
    <div class="login-container" v-if="loaded">
        <Message :message="message" :type="type" v-if="message !== null"></Message>
        <h1>{{$t('password-reset.title')}}</h1>
        <form @submit.prevent="reset" class="login">
            <div class="inputs">
                <input :placeholder="$t('password-reset.email')" required type="email" v-model="username"/>
            </div>
            <div class="buttons">
                <button class="login-button" type="submit">{{$t('password-reset.resetButton')}}</button>
            </div>

        </form>
    </div>
    <preloader v-else></preloader>
</template>

<script>
import { RepositoryFactory } from '@/api/RepositoryFactory';
import { ServerError } from '@/api/user/erros';
import Message from '@/components/helpers/Message';
import Preloader from '@/components/helpers/Preloader';

const UserRepository = RepositoryFactory.get('users');
export default {
  name: 'PasswordReset',
  components: {
    Preloader,
    Message,
  },
  data() {
    return {
      username: '',
      message: null,
      type: 'info',
      loaded: true,
    };
  },
  mounted() {
    console.log(this.$i18n.availableLocales);
    console.log(navigator.language);
  },
  methods: {
    async reset() {
      if (this.username) {
        this.loaded = false;
        try {
          const currentPath = window.location.href;
          const currentRoutePath = this.$router.currentRoute.fullPath;

          const frontendPath = `${currentPath.replace(currentRoutePath, '')}/password-reset`;
          await UserRepository.passwordReset({
            username: this.username,
            domain: frontendPath,
            locale: this.$i18n.locale,
          });
          localStorage.clear();
          this.message = this.$t('password-reset.resetMessage');
        } catch (error) {
          if (error instanceof ServerError) {
            this.message = this.$t('errors.genericError');
          } else {
            this.message = this.$t('password-reset.errors.userNotFound');
          }
          this.type = 'error';
        }
        this.loaded = true;
        return true;
      }
      this.message = this.$t('password-reset.errors.email');
      return false;
    },
  },
};
</script>

<style lang="scss" scoped>
    .login-container {
        width: 500px;
        margin: 200px auto;
        margin-bottom: 0;
        @include media('<540px') {
            width: 90%;
        }

        h1 {
            font-size: rem(30px);
            font-weight: bold;
            // // color: $baseTextColor;
            margin-bottom: 20px;
            text-align: left;

        }

        .login {

            .inputs {
                display: flex;
                flex-direction: column;

                input {
                    margin: 20px 0;
                    border: 1px solid $border-gray;
                    border-radius: 5px;
                    box-shadow: 0 1px 8px rgba(0, 0, 0, 0.16);
                    font-size: rem(14px);
                    padding: 14px 0 14px 30px;
                }
            }

            .buttons {
                display: flex;
                justify-content: space-between;
                margin-top: 40px;
                align-items: center;

                a {
                    text-decoration: none;
                    color: $peacock-blue;

                }

                button {
                    color: white;
                    font-weight: bold;
                    font-size: rem(18px);
                    background-color: $peacock-blue;
                    padding: 12px 50px;
                    border-radius: 30px;
                    border: 1px solid $peacock-blue;
                    transition: 300ms all ease-in;
                    cursor: pointer;
                    display: inline-block;
                    margin: 0 auto;

                    &:hover {
                        color: $peacock-blue;
                        background-color: white;
                    }
                }
            }
        }
    }

</style>
